var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFraxicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C10.8128 25 9.1759 24.6693 7.63423 24.0175C6.14549 23.3878 4.80932 22.4864 3.66101 21.339C2.51358 20.1916 1.61222 18.8545 0.982502 17.3658C0.330735 15.8241 0 14.1872 0 12.5C0 10.8128 0.330735 9.1759 0.982502 7.63423C1.61222 6.14549 2.51358 4.80932 3.66101 3.66101C4.80932 2.51358 6.14549 1.61222 7.63423 0.982502C9.1759 0.330735 10.8128 0 12.5 0C14.1872 0 15.8241 0.330735 17.3658 0.982502C18.8545 1.61222 20.1907 2.51358 21.339 3.66101C22.4864 4.80844 23.3878 6.14549 24.0175 7.63423C24.6693 9.1759 25 10.8128 25 12.5C25 14.1872 24.6693 15.8241 24.0175 17.3658C23.3878 18.8545 22.4864 20.1907 21.339 21.339C20.1916 22.4864 18.8545 23.3878 17.3658 24.0175C15.8241 24.6701 14.1872 25 12.5 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 24.3377C19.0375 24.3377 24.3374 19.0378 24.3374 12.5C24.3374 5.96225 19.0375 0.662354 12.4998 0.662354C5.96201 0.662354 0.662109 5.96225 0.662109 12.5C0.662109 19.0378 5.96201 24.3377 12.4998 24.3377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7364 12.5C18.7364 11.2317 18.3554 10.0517 17.7028 9.06565L19.6387 7.12975L17.8977 5.38876L15.9671 7.31937C14.9757 6.65349 13.7833 6.26455 12.5019 6.26455C11.2336 6.26455 10.0535 6.64555 9.06751 7.2982L7.13073 5.3623L5.38974 7.10329L7.32035 9.0339C6.65447 10.0252 6.26552 11.2176 6.26552 12.4991C6.26552 13.7674 6.64653 14.9474 7.29918 15.9335L5.36328 17.8702L7.10427 19.6112L9.03488 17.6806C10.0262 18.3465 11.2186 18.7354 12.5001 18.7354C13.7683 18.7354 14.9484 18.3544 15.9344 17.7018L17.8712 19.6386L19.6122 17.8976L17.6816 15.967C18.3475 14.9739 18.7364 13.7815 18.7364 12.5ZM8.72884 12.5C8.72884 10.4195 10.4213 8.72698 12.5019 8.72698C14.5824 8.72698 16.2749 10.4195 16.2749 12.5C16.2749 14.5805 14.5824 16.273 12.5019 16.273C10.4213 16.273 8.72884 14.5805 8.72884 12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraxicon);
export default __webpack_public_path__ + "static/media/fraxicon.5c0e1e7eda74b5e98bacc97d02c02cc3.svg";
export { ForwardRef as ReactComponent };